/**
 * @desc 查询箱子详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.SupplierBoxResponseDto>;
export function request(boxCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierBox/getBoxInfoByBoxCode/${boxCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
